import "./Header.css";

type HeaderProps = {
  title: string;
  online?: boolean;
  user: string;
  onLogout?: () => void;
};

export default function Header({
  title,
  online = true,
  user,
  onLogout,
}: HeaderProps) {
  const initial =
    user.trim().charAt(0).toUpperCase() || "?";

  return (
    <header className="header">
      <div className="header-left">
        <div className="logo">
          ☀
        </div>

        <div className="header-copy">
          <h1>{title}</h1>

          <span
            className={
              online
                ? "online"
                : "offline"
            }
          >
            {online
              ? "● Online"
              : "● Offline"}
          </span>
        </div>
      </div>

      <button
        type="button"
        className="userButton"
        onClick={onLogout}
        title={`Sair de ${user}`}
        aria-label={`Sair da conta de ${user}`}
      >
        {initial}
      </button>
    </header>
  );
}